export enum DanceClassToUserTypeEnum {
  STUDENT = "STUDENT",
  TEACHER = "TEACHER",
  FAVORITE = "FAVORITE"
}
